import script from "./SingleDigitInputComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleDigitInputComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SingleDigitInputComponent.vue?vue&type=style&index=0&id=29bf4146&lang=css"

const __exports__ = script;

export default __exports__